export default "__VITE_ASSET__2d048e55__"